export const normaliseCostTableName = (name: string): string =>
  name.trim().toLowerCase();
